export const fileExtensions = ".jpg,.jpeg,.png,.webp";